import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./css/index.css";

ReactDOM.render(
  <main>
    <App />
  </main>,
  document.getElementById("root")
);
